var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAustralia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 20.0001C39.9998 31.0457 31.0454 40.0001 19.9998 40.0001C8.95413 40.0001 -0.000244141 31.0457 -0.000244141 20.0001C-0.000244141 20.0047 19.9998 0.00232666 19.9998 6.10352e-05C31.0454 6.10352e-05 39.9998 8.95444 39.9998 20.0001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 6.10352e-05C19.999 6.10352e-05 19.9977 0.000143156 19.9966 0.000143156L20.0001 6.10352e-05Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9464 20H19.9999C19.9999 19.9819 19.9999 19.9646 19.9999 19.9465C19.9821 19.9644 19.9643 19.9822 19.9464 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.4349C20 6.91575 20 4.60973 20 0.00012207H19.9966C8.9525 0.00191895 0 8.95543 0 20H10.4348V14.1241L16.3107 20H19.9466C19.9645 19.9822 19.9823 19.9644 20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3109L14.1241 10.4349H20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1183 2.6087C6.99028 4.38988 4.38981 6.99034 2.60864 10.1184V20H7.82606V7.8262V7.82613H20C20 6.18058 20 4.61292 20 2.6087H10.1183Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.5406L12.8943 10.435H10.4348C10.4348 10.4349 10.4348 10.435 10.4348 10.435L19.9999 20H20C20 20 20 18.3043 20 17.5406Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0621 23.4783L13.1598 25.7734L15.6385 25.2005L14.5285 27.4898L16.5218 29.0705L14.04 29.6298L14.0469 32.1739L12.0621 30.5823L10.0775 32.1739L10.0844 29.6298L7.60254 29.0705L9.5959 27.4898L8.48574 25.2005L10.9646 25.7734L12.0621 23.4783Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9441 27.8261L30.4929 28.9737L31.7323 28.6872L31.1772 29.8318L32.174 30.6222L30.933 30.9019L30.9365 32.1739L29.9441 31.3781L28.9518 32.1739L28.9552 30.9019L27.7144 30.6222L28.711 29.8318L28.156 28.6872L29.3953 28.9737L29.9441 27.8261Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8386 15.6522L25.3874 16.7998L26.6267 16.5133L26.0717 17.6579L27.0684 18.4483L25.8275 18.7279L25.8309 20L24.8386 19.2041L23.8463 20L23.8496 18.7279L22.6088 18.4483L23.6054 17.6579L23.0504 16.5133L24.2898 16.7998L24.8386 15.6522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9441 8.69562L30.4929 9.84327L31.7323 9.55679L31.1773 10.7014L32.1739 11.4917L30.933 11.7715L30.9365 13.0435L29.9441 12.2476L28.9518 13.0435L28.9552 11.7715L27.7144 11.4917L28.7109 10.7014L28.156 9.55679L29.3953 9.84327L29.9441 8.69562Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4037 13.9131L34.9524 15.0607L36.1918 14.7742L35.6368 15.9188L36.6334 16.7092L35.3925 16.9889L35.3959 18.2609L34.4037 17.4651L33.4113 18.2609L33.4147 16.9889L32.1738 16.7092L33.1705 15.9188L32.6155 14.7742L33.8548 15.0607L34.4037 13.9131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2148 20L31.6464 21.3286H33.0435L31.9132 22.1498L32.345 23.4783L31.2148 22.6572L30.0846 23.4783L30.5163 22.1498L29.3861 21.3286H30.7831L31.2148 20Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default __webpack_public_path__ + "static/media/australia.d662ec3d220a7808596786c2f47bb419.svg";
export { ForwardRef as ReactComponent };